import { ProjectSettingsActions } from '../actions/ProjectSettingsActions';
import { ProjectSettingsStoreState, ProjectSettingsStore } from '../stores/ProjectSettingsStore';
import { FloorPlanContentFileName, FloorPlanManager } from './FloorPlanManager';

import core = egr.wcf.core;
import utils = egr.wcf.utils;

export class ProjectSettingsModule extends core.AppModule {
    public readonly moduleId: string = 'pCon.box.ProjectSettings';

    public async loadDocumentData(context: core.io.DocumentInputContext, data: core.io.DataMap): Promise<void> {
        if (data != null) {
            ProjectSettingsActions.importState(data as ProjectSettingsStoreState);

            try {
                const floorPlan: string = await context.getResource(FloorPlanContentFileName, false) as string;
                if (!utils.string.isNullOrEmpty(floorPlan)) {
                    FloorPlanManager.importFloorPlanFromContainer(floorPlan);
                }
            } catch (error) {
                // ignore file not found erro
                if (!(error instanceof core.io.FileNotFoundError)) {
                    throw error;
                }
            }
        }

        return Promise.resolve();
    }

    public async saveDocumentData(context: core.io.DocumentOutputContext, options: core.AppDocumentSaveOptions): Promise<core.io.DataMap> {
        // FixMe: replace the `compressionLevel` check with a check of the type of the DocmumentContainer or something like that
        const floorPlan: string | null = await FloorPlanManager.getFloorPlan();
        if (utils.string.isNotNullOrEmpty(floorPlan)) {
            await context.addResource(floorPlan, FloorPlanContentFileName, false);
        }

        return Promise.resolve(ProjectSettingsStore.getState());
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/ProjectSettingsModule.ts